import { useState } from 'react';
import StringHelper from 'utilities/stringHelper';
import { birthYearMatchesPassword, birthDayMatchesPassword } from 'commonsUtilities/validations';
import validator from 'validator';

export const PASSWORD_LENGTH = 4;

const INITIAL_PASSWORD_STATE = {
    hasErrors: false,
    passNumeric: true,
    passAscDesc: true,
    passEquals: true,
    passBirthYear: true,
    passBirthDay: true,
};

export const usePassword = ({ onCustomError, formActions, birthDay, birthMonth, birthYear, setIsValidPass }) => {
    const [passwordState, setPasswordState] = useState(INITIAL_PASSWORD_STATE);

    const setBirthDayMonthValidation = (formActions, valid) => {
        formActions.setValidity('userProfile.birthDay', { required: valid });
        formActions.setValidity('userProfile.birthMonth', { required: valid });
        formActions.setValidity('userProfile.birthDate', {
            validPinBirthDate: valid,
        });
    };

    const setBirthYearValidation = (formActions, valid) => {
        formActions.setValidity('userProfile.birthYear', { required: valid });
        formActions.setValidity('userProfile.birthDate', {
            validPinBirthDate: valid,
        });
    };

    const handlePasswordRequirements = (...args) => {
        const [passAscDesc, passEquals, passBirthYear, passBirthDay] = args;
        const hasErrors = args.some(x => !x);
        if (hasErrors)
            onCustomError({
                passAscDesc,
                passEquals,
                passBirthYear,
                passBirthDay,
            });
        setPasswordState({
            hasErrors,
            passAscDesc,
            passEquals,
            passBirthYear,
            passBirthDay,
        });
    };

    const handleOnChange = event => {
        event.target.value = StringHelper.getDigitsOnly(event.target.value);
        if (!event.target.value) {
            handlePasswordRequirements(true, true, true, true);
        } else if (event.target.value.length >= PASSWORD_LENGTH) {
            event.target.blur();
        }
    };

    const handleValidations = {
        required: value => {
            if (value && value.length) {
                return true;
            }

            return false;
        },
        valid: value => {
            const asc = '0123456789';
            const des = '9876543210';

            let valid = true;
            let passAscDesc = true;
            let passEquals = true;

            const validYear = birthYearMatchesPassword(value, birthYear);
            const validDayMonth = birthDayMatchesPassword(value, birthDay, birthMonth);
            const passBirthYear = !validYear;
            const passBirthDay = !validDayMonth;

            passBirthYear && setBirthYearValidation(formActions, true);
            passBirthDay && setBirthDayMonthValidation(formActions, true);

            valid = !(validYear || validDayMonth);

            const isValidLength = value.length === PASSWORD_LENGTH;
            const isNumeric = validator.matches(value, /^[0-9]{4}$/);
            const isSequential = asc.includes(value) || des.includes(value);
            const isRepeating = /^(\d)(?:\1)*$/.test(value);

            if (isValidLength) {
                if (!isNumeric) {
                    valid = false;
                } else if (isSequential) {
                    valid = false;
                    passAscDesc = false;
                } else if (isRepeating) {
                    valid = false;
                    passEquals = false;
                }
            } else if (document.activeElement.id !== 'password') {
                valid = false;
            }

            handlePasswordRequirements(passAscDesc, passEquals, passBirthYear, passBirthDay);
            setIsValidPass(isValidLength && valid);

            return valid;
        },
    };
    const resetState = () => {
        setPasswordState(INITIAL_PASSWORD_STATE);
    };

    return {
        state: passwordState,
        handleValidations,
        handleOnChange,
        resetState,
    };
};
